import React, { useState } from 'react';
import { Globe } from 'react-feather';
import Modal from '../Modal/Modal';
import styles from './LanguageSelector.module.css';
import localisation from '../../localisation.json';
import { RestartContext } from '../RestartContext/RestartContext';
import Flag from '../flags/Flag';

function LanguageSelector({ language, setLanguage }) {
    const [isOpen, setIsOpen] = useState(false);
    const { triggerRestart } = React.useContext(RestartContext);
    const handleLanguageChange = (event) => {
        setLanguage(event.target.value);
        triggerRestart();
        localStorage.setItem('language', event.target.value);
    };

    return (
        <div>
            <button
                className={`${styles.globe} hoverable-btn`}
                onClick={() => setIsOpen(true)}>
                <Globe className='header-icon' />
                <p className='selected-language'>{language}</p>
            </button>
            <div>
                <Modal
                    isOpen={isOpen}
                    title={
                        <div className={styles.title}>
                            {localisation[0].languageModalHeader[language]}
                        </div>
                    }
                    handleDismiss={() => setIsOpen(false)}>
                    <div>
                        {localisation[0].languagesList.map((item) => (
                            <div key={item.value}>
                                <label
                                    style={{
                                        display: 'flex',
                                        gap: 7,
                                        alignItems: 'center',
                                    }}>
                                    <input
                                        type='radio'
                                        value={item.value}
                                        checked={language === item.value}
                                        onChange={handleLanguageChange}
                                    />
                                    <Flag
                                        width='20'
                                        height='20'
                                        country={item.value}
                                    />
                                    {item.label}
                                </label>
                            </div>
                        ))}
                    </div>
                </Modal>
            </div>
        </div>
    );
}

export default LanguageSelector;
